module.exports = __webpack_public_path__ + "static/media/amex.75af16dc.svg";